import React from "react";
import { eventAttrBuilder } from "./utility";
import "../../styles/fix.scss"; // temp emquanto o Isel não consegue enviar html no serviço

const PackOffer = (props) => {
  const {
    currentPack,
    currentWeights,
    packIdx,
    selectedState,
    handleChange,
    resume,
  } = props;

  // if pack has no offer then return nothing
  if (!currentPack.offer) return null;

  // caso tenha offers pinta o title offer em h4 e o radios
  // caso contrário pinta o title offer em h5 sem os radios
  // no final pode pintar sempre o texto da descrição da offerta
  return (
    <div className="pack-offers">
      {currentWeights.offers?.length > 0 ? (
        <React.Fragment>
          <h4 className="offer-title">{currentPack.offer.text}</h4>
          <div className="offer-radios">
            {currentWeights.offers.map((item, idx) => {
              const itemId = ["pack", packIdx, "offers", item.id].join("_");
              return (
                <div className="radio-item" key={itemId}>
                  <label
                    htmlFor={itemId}
                    {...eventAttrBuilder(
                      packIdx + 1,
                      currentPack.event.region,
                      currentPack.title,
                      2,
                      "n/a",
                      item.title,
                      idx + 1
                    )}
                  >
                    {item.title}
                  </label>
                  <input
                    type="radio"
                    id={itemId}
                    name={["pack", packIdx, "offers"].join("_")}
                    checked={selectedState.offers == item.id}
                    onChange={handleChange("offers", item.id, item.idInternal)}
                  />
                  <span></span>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      ) : (
        <h5 className="offer-title">{currentPack.offer?.text}</h5>
      )}
      {currentPack.offer?.description ? (
        //suggestion não aparece caso seja o resumo do pacote
        resume && currentPack.offer.description.type === "Suggestion" ? null : (
          <div
            className="offer-desc"
            dangerouslySetInnerHTML={{
              __html: currentPack.offer.description?.text || "",
            }}
          />
        )
      ) : null}
    </div>
  );
};

export default PackOffer;
